'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/scheduler-tracing.production.min.js');
} else {
  module.exports = require('./cjs/scheduler-tracing.development.js');
}



//////////////////
// WEBPACK FOOTER
// /Users/bvzk/Local Sites/xpansiv/app/public/wp-content/themes/xpansiv-wordpress/node_modules/scheduler/tracing.js
// module id = 180
// module chunks = 0